module.exports = __webpack_public_path__ + "img/workout-notebook_B095QBPBZQ.a9472cfa.jpg";